import { default as Mui5FormControl } from '@mui/material/FormControl'

export const FormControl = Mui5FormControl
